module.exports = __webpack_public_path__ + "img/Rainbow.6c655b75.png";